import { ReferenceDataConstants } from '../../constants/reference-data-constants';
import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { Deserializable } from '../deserializable';
import { CaseActionsInfoViewModel } from '../interfaces/case-actions-info-viewmodel.model';

export class ApplicationCase implements Deserializable, CaseActionsInfoViewModel {
  public CaseNumber: number;
  public AgentID?: number;
  public DateCreated?: Date;
  public NumberOfApplicantsCache?: number;
  public LoanGroupTypeCode: string;
  public PurchaseOrRemortgageCode: string;
  public PropertyLocationCode: string;
  public DateModified?: Date;
  public CaseStatusCode: string;
  public AllocatedStaffID?: number;
  public MortgageStatusCode: string;
  public LockStaffID?: number;
  public PrimaryApplicantFullNameCache: string;
  public AllApplicantsFullNameCache: string;
  public DateLastSubmittedCache?: Date;
  public HasSelfEmployedCache?: boolean;
  public LoanTypeCodeCache: string;
  public ProductID?: number;
  public LtvCache?: number;
  public MainApplicantPostcode: string;
  public PropertyPostcodeCache: string;
  public LastRomeStatusCode: string;
  public SamDownloadDate?: Date;
  public Scoreband: string;
  public TransactHighestPolicyRule: string;
  public ProductCodeCache: string;
  public ProductNameCache: string;
  public LoanGroupCodeCache: string;
  public SamIDCache: string;
  public SamIDCacheAsHash: string;
  public RepaymentTypeCodeCache: string;
  public LoanTermYearsCache?: number;
  public LoanTermMonthsCache?: number;
  public LoanAmountCache?: number;
  public LastMortgageApplicationID?: number;
  public DateStatusLastModified?: Date;
  public CaseStatusSortOrderCache?: number;
  public BranchID?: number;
  public BranchUserID?: number;
  public PropositionIDCache?: number;
  public InterfaceTypeIDCache?: number;
  public ReferringBranch: string;
  public ReferringIndividual: string;
  public MarketingReference: string;
  public DirectCustomerID?: number;
  public EligibilityInterestOnlyAnswerCode: string;
  public BTLLoanTypeCode: string;
  public AxosCaseNumber: string;
  public WasPackagingGenerated?: boolean;
  public NextPackagingNotificationDate?: Date;
  public TurnOffPackagingNotifications?: boolean;
  public IsQualifiedForPackaging?: boolean;
  public WasPackagingPublished?: boolean;
  public BeforeAssessCaseStatusCode: string;
  public WasLastMortgageApplicationAccepted?: boolean;
  public WasMaterialChangeApplied?: boolean;
  public SAMWorkflowDate?: Date;
  public HasAFullAssessmentTaskBeenCompleted?: boolean;
  public HasAFullAssessmentTaskBeenCreated?: boolean;
  public WhereDidUserHearAboutProduct?: number;
  public AdviceOwnerTeamCode: string;
  public AdviceOwnerStaffID?: number;
  public CaseType: string;
  public ServiceLevelCode: string;
  public IsAdviceInProgress?: boolean;
  public CreationSource: string;
  public IsOffline?: boolean;
  public SwitchStatusCode: string;
  public CreatedBy: string;
  public LinkedCaseNumber?: number;
  public AS400NumbersCache: string;
  public WasApplicationAcceptedWithoutAipCertificate?: boolean;
  public PackagingStageCode: string;
  public ArePackagingDocumentsDeleted?: boolean;
  public IsStagedPaymentCache?: boolean;
  public WasEverCompleted: boolean;
  public PackagingDocumentsDeletedDate?: Date;
  public OfferChannelCodeCache: string;
  public OfferStatusCodeCache: string;
  public IsChaseOfferNotificationDisabled?: boolean;
  public CaseNumberAsHash: string;
  public IsInAdviceStage: boolean;
  public IsAdvisedCase: boolean;
  public IsResidential: boolean;
  public IsBranchCase: boolean;
  public IsDirectCase: boolean;
  public IsSwitchInProgress: boolean;
  public ArePackagingNotificationTasksDisabled: boolean;

  public IsBrokerCase: boolean;
  public IsNewBusinessCase: boolean;
  public HasBranchDetails: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    this.IsBrokerCase = this.InterfaceTypeIDCache === ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID;

    this.IsNewBusinessCase =
      this.CaseType === ReferenceDataOptionLists.CaseTypeAdvisedOption ||
      this.CaseType === ReferenceDataOptionLists.CaseTypeNonAdvisedOption;

    this.HasBranchDetails = this.BranchID !== null;

    return this;
  }
}
